import { RouteProp } from "@react-navigation/native";
import { Suspense } from "react";
import { RelayEnvironmentProvider } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";
import {
  useRelayPrivateEnvironment,
  useRelayPrivateQueryEnvironment,
} from "@whoosh/relay/src";

import { AuthenticationErrorBoundary } from "../../features/Authentication/components/AuthenticationErrorBoundary";
import { useSchemaVersionMismatchHandler } from "../../features/OtaUpdateOverlay";
import { BaseNavigatorParamList } from "../../navigators/BaseNavigator/types";
import { ClubQuerier } from "./components/ClubQuerier";
import { ClubQueueItPreflight } from "./components/ClubQueueItPreflight";

type Props = {
  route: RouteProp<BaseNavigatorParamList, "Club">;
};

export const ClubScreen = ({ route }: Props) => {
  const { clubSlug } = route.params;

  return <ClubScreenForSlug clubSlug={clubSlug} key={clubSlug} />;
};

const ClubScreenForSlug = ({ clubSlug }: { clubSlug: string }) => {
  const schemaVersionMismatchHandler = useSchemaVersionMismatchHandler();
  const PreflightEnvironment = useRelayPrivateQueryEnvironment({
    schemaVersionMismatchHandler,
    clubSlug,
  });

  return (
    <RelayEnvironmentProvider environment={PreflightEnvironment}>
      <Suspense fallback={<Loader />}>
        <ClubQueueItPreflight clubSlug={clubSlug}>
          <ClubRelayScreenForSlug clubSlug={clubSlug} />
        </ClubQueueItPreflight>
      </Suspense>
    </RelayEnvironmentProvider>
  );
};

const ClubRelayScreenForSlug = ({ clubSlug }: { clubSlug: string }) => {
  const schemaVersionMismatchHandler = useSchemaVersionMismatchHandler();
  const PrivateEnvironment = useRelayPrivateEnvironment({
    schemaVersionMismatchHandler,
    clubSlug,
  });

  return PrivateEnvironment ? (
    <RelayEnvironmentProvider environment={PrivateEnvironment}>
      <AuthenticationErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ClubQuerier clubSlug={clubSlug} />
        </Suspense>
      </AuthenticationErrorBoundary>
    </RelayEnvironmentProvider>
  ) : (
    <Loader />
  );
};
